<div class="chi-med-expire-tool">
  <div class="chi-med-expire-tool__actions">
    <app-vis-button icon="edit" label="新增一筆" (click)="addRow()"></app-vis-button>
    <app-vis-button icon="save" label="儲存" styleType="primary" (click)="Save()"></app-vis-button>
  </div>
  <div class="chi-med-expire-tool__table-wrapper">
    <table>
      <thead>
        <tr>
          <th class="chi-med-expire-tool__date-cell">截止日期</th>
          <th>代碼</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data; index as i">
          <td class="chi-med-expire-tool__date-cell">
            <app-vis-datepicker
              [(ngModel)]="row.EndDate"
              class="chi-med-expire-tool__datepicker"
              [maxWidth]="false"
            ></app-vis-datepicker>
          </td>
          <td>
            <textarea
              class="vis-input chi-med-expire-tool__std-code"
              [(ngModel)]="row.StdCodes"
              rows="3"
              placeholder="請輸入代碼"
            ></textarea>
          </td>
          <td>
            <app-vis-button
              label="刪除"
              icon="delete"
              styleType="warning"
              fontSize="xs"
              (click)="deleteRow(i)"
            >
            </app-vis-button>
          </td>
        </tr>
        <tr *ngIf="!data?.length">
          <td colspan="3" class="chi-med-expire-tool__empty">尚無資料</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
